import React, { useState, useEffect, useRef } from "react";
import * as Material from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, Text } from "@fragments";
import Parser from "@helpers/parser.js";
import api from "@helpers/api.js";
import AnimatedText from "@components/SmallComponents/AnimatedText";
import RequestWithdrawalModal from "@components/_modals/Billing/RequestWithdrawalModal";

import './styles.scss';

export default function Balance() {
    const [loading, setLoading] = useState(true);
    const [account, setAccount] = useState(null);
    const REF_requestWithdrawalModal = useRef(null);
    const [isVisible, setIsVisible] = useState(() => {
        const stored = localStorage.getItem('banking-values-visible');
        return stored ? JSON.parse(stored) : false;
    });

    useEffect(() => {
        if (loading) handleLoad();
    }, [loading]);

    async function handleLoad() {
        try {
            const { data } = await api.get("wallet");
            setAccount(data);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }

    function toggleVisibility() {
        const newValue = !isVisible;
        setIsVisible(newValue);
        localStorage.setItem('banking-values-visible', JSON.stringify(newValue));
    }

    function handleRequestWithdrawal() {
        REF_requestWithdrawalModal.current.open({
            wallet: account,
            amount: parseInt(account?.balance?.available),
        }, () => setLoading(true))
    }

    return (
        <div className="balance-section">
            <div className="balance-header">
                <Text.span weight={300} contrast={6}>
                    Saldo disponível para saque
                </Text.span>
                <Button
                    size="small"
                    color="text"
                    onClick={toggleVisibility}
                    icon={!isVisible ? <VisibilityOff /> : <Visibility />}
                    className="visibility-toggle"
                />
            </div>

            <div className="animated-balance">
                {loading ? (
                    <Material.Skeleton
                        variant="text"
                        width={150}
                        height={38}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            '&::after': {
                                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                            }
                        }}
                    />
                ) : (
                    <div className="balance-box">
                        <AnimatedText
                            weight={500}
                            contrast={10}
                            text={`R$ ${isVisible ? Parser.price.brl(account?.balance?.available) || '0,00' : '••••••'}`}
                            component="h2"
                            className="animated-balance"
                        />
                        {parseInt(account?.balance?.available) >= 500 && (
                            <Button
                                size="small"
                                onClick={handleRequestWithdrawal}
                                color="inverse"
                                text="Solicitar saque"
                            />
                        )}
                    </div>
                )}
            </div>

            <RequestWithdrawalModal modalRef={REF_requestWithdrawalModal} />
        </div>
    );
}
